module.exports = __webpack_public_path__ + "img/horizontal-logo.0d80365a.svg";